import React, { ReactNode } from 'react';
import { Modal, Spin } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';

import './BaseModal.less';

interface UseStylesProps {
  maxWidth: number;
}

const useStyles = createUseStyles({
  modalRoot: {
    // 15 * 2 = 30 - side gutter for mobile screen
    maxWidth: (props: UseStylesProps) => props.maxWidth + 30,
  },
});

type BaseModalOwnProps = {
  children?: ReactNode;
  isLoading?: boolean;
  maxWidth?: number;
};

export type BaseModalProps = ModalProps & BaseModalOwnProps;

export default function BaseModal(props: BaseModalProps) {
  const {
    maskClosable = false,
    isLoading = false,
    closable = true,
    footer = null,
    className = '',
    maxWidth = 898,
    children,
    ...rest
  } = props;
  const classes = useStyles({ maxWidth });

  return (
    <Modal
      width="100%"
      footer={footer}
      closable={closable}
      maskClosable={maskClosable}
      className={classNames(className, classes.modalRoot, 'modal-root')}
      {...rest}
    >
      {!isLoading && children}
      {isLoading && <Spin size="large" />}
    </Modal>
  );
}
